"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapRegionToBillingCountries = exports.mapBillingCountryToRegion = exports.regionMapping = void 0;
const initCapWords = (str) => {
    const tokens = str.split(' ');
    return tokens
        .map((token) => {
        if (['and', 'of', 'the'].includes(token))
            return token;
        return token.charAt(0).toUpperCase() + token.slice(1);
    })
        .join(' ');
};
exports.regionMapping = {
    ANZ: [
        'AU',
        'AUS',
        'Australia',
        'Fiji',
        'Kiribati',
        'Marshall Islands',
        'Micronesia',
        'NZ',
        'Nauru',
        'New Zealand',
        'Palau',
        'Papua New Guinea',
        'Samoa',
        'Solomon Islands',
        'Tonga',
        'Tuvalu',
        'Vanuatu',
    ],
    China: ['China'],
    Singapore: ['Philippines', 'Singapore', 'Malaysia'],
    Korea: ['Korea', 'South Korea', 'South, Korea', 'Korea, South'],
    'APAC 1': ['HK', 'Hong Kong', 'Hong Kong - SAR', 'Hong Kong SAR', 'Hong Kong-SAR', 'Macau', 'Taiwan'],
    'APAC 2': [
        'Bhutan',
        'Brunei',
        'Cambodia',
        'East Timor',
        'Indonesia',
        'Laos',
        'Myanmar',
        'Myanmar (Burma)',
        'Nepal',
        'Thailand',
        'Timor-Leste',
        'Viet Nam',
        'Vietnam',
    ],
    Japan: ['Japan'],
    CIS: [
        'Armenia',
        'Azerbaijan',
        'Belarus',
        'Estonia',
        'Georgia',
        'Kazakhstan',
        'Kazakshtan',
        'Kyrgystan',
        'Kyrgyzstan',
        'Latvia',
        'Lithuania',
        'Moldova',
        'Mongolia',
        'Russia',
        'Tajikistan',
        'Turkmenistan',
        'Ukraine',
        'Uzbekistan',
    ],
    'EU UK': [
        'Albania',
        'Andorra',
        'Austria',
        'Belgium',
        'Bosnia & Herzegovina',
        'Bosnia and Herzegovina',
        'Bulgaria',
        'Croatia',
        'Cyprus',
        'Czech Republic',
        'Denmark',
        'England',
        'Faroe Islands',
        'Finland',
        'France',
        'Germany',
        'Greece',
        'Holy See',
        'Hungary',
        'Iceland',
        'Ireland',
        'Italy',
        'Liechtenstein',
        'Luxembourg',
        'Malta',
        'Monaco',
        'Montenegro',
        'Netherlands',
        'North Macedonia',
        'Northern Ireland',
        'Norway',
        'Poland',
        'Portugal',
        'Romania',
        'San Marino',
        'Scotland',
        'Serbia',
        'Slovakia',
        'Slovenia',
        'Spain',
        'Sweden',
        'Switzerland',
        'Switzerland.Switzerland',
        'UK',
        'United Kindom',
        'United Kingdom',
        'Wales',
    ],
    USCA: ['Canada', 'Estados Unidos', 'US', 'USA', 'United States', 'United States of America'],
    LATAM: [
        'Antigua and Barbuda',
        'Argentina',
        'Bahamas',
        'Barbados',
        'Belize',
        'Bolivia',
        'Brasil',
        'Brazil',
        'Cayman Islands',
        'Chile',
        'Colombia',
        'Costa Rica',
        'Cuba',
        'Dominica',
        'Dominican Republic',
        'Ecuador',
        'El Salvador',
        'Grenada',
        'Guatemala',
        'Guyana',
        'Haiti',
        'Honduras',
        'Jamaica',
        'Mexico',
        'Nicaragua',
        'Panama',
        'Paraguay',
        'Peru',
        'Saint Kitts & Nevis',
        'Saint Kitts and Nevis',
        'Saint Lucia',
        'Saint Vincent and the Grenadines',
        'Suriname',
        'Trinidad & Tobago',
        'Trinidad and Tobago',
        'Uruguay',
        'Venezuela',
    ],
    MESA: [
        'Afghanistan',
        'Algeria',
        'Angola',
        'Bahrain',
        'Bangladesh',
        'Benin',
        'Botswana',
        'Burkina Faso',
        'Burundi',
        'Cabo Verde',
        'Cameroon',
        'Cape Verde',
        'Central African Republic',
        'Chad',
        'Comoros',
        'Congo',
        'Democratic Republic of the Congo',
        'Djibouti',
        'Egypt',
        'Equatorial Guinea',
        'Eritrea',
        'Eswatini',
        'Ethiopia',
        'Gabon',
        'Gambia',
        'Ghana',
        'Guinea',
        'Guinea-Bissau',
        'Iraq',
        'Islamic Rep. of Iran',
        'Israel',
        'Jordan',
        'Kenya',
        'Kuwait',
        'Lebanon',
        'Lesotho',
        'Liberia',
        'Libya',
        'Madagascar',
        'Malawi',
        'Maldives',
        'Mali',
        'Mauritania',
        'Mauritius',
        'Morocco',
        'Mozambique',
        'Namibia',
        'Niger',
        'Nigeria',
        'Oman',
        'Palestine State',
        'Qatar',
        'Rwanda',
        'Sao Tome and Principe',
        'Saudi Arabia',
        'Senegal',
        'Seychelles',
        'Sierra Leone',
        'Somalia',
        'South Africa',
        'South Sudan',
        'Sri Lanka',
        'Sudan',
        'Syria',
        'Tanzania',
        'Togo',
        'Tunisia',
        'Turkey',
        'Türkiye',
        'UAE',
        'Uganda',
        'United Arab Emirates',
        'Yemen',
        'Zambia',
        'Zimbabwe',
    ],
    India: ['India', 'Pakistan'],
    Global: ['Global Sales', 'Rest of World'],
};
const mapBillingCountryToRegion = (billingCountry) => {
    if (!billingCountry)
        return null;
    for (const region in exports.regionMapping) {
        if (exports.regionMapping[region].includes(initCapWords(billingCountry))) {
            return region;
        }
    }
    return null;
};
exports.mapBillingCountryToRegion = mapBillingCountryToRegion;
const mapRegionToBillingCountries = (region) => {
    var _a;
    return (_a = exports.regionMapping[region]) !== null && _a !== void 0 ? _a : [];
};
exports.mapRegionToBillingCountries = mapRegionToBillingCountries;
//# sourceMappingURL=billingCountryStrategistRegionMapping.js.map